import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MdButtonModule, MdCardModule, MdMenuModule, MdToolbarModule, MdIconModule, MdTabsModule, MdDatepickerModule, MdNativeDateModule } from '@angular/material';
import { MdInputModule, MdCheckboxModule, MdRadioModule, MdProgressSpinnerModule, MdSelectModule, MdExpansionModule, MdProgressBar } from '@angular/material';
import { AppComponent } from './app.component';
import { OffCanvasMenuComponent } from './off-canvas-menu/off-canvas-menu.component';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ControlMessagesComponent } from './control-messages.component';
import { ValidationService } from './validation.service';
import { ApplyJobSection1Component } from './apply-job-section1/apply-job-section1.component';
import { ApplyJobSection2Component } from './apply-job-section2/apply-job-section2.component';
import { ApplyJobSection3Component } from './apply-job-section3/apply-job-section3.component';
import { ApplyJobSection4Component } from './apply-job-section4/apply-job-section4.component';

import { JobService } from './jobService';
//import { AttacthService } from './AttacthService';
import { Educational } from './educational';
import { Experience } from './experience';
import { ApplyJobSection5Component } from './apply-job-section5/apply-job-section5.component';
import { ApplyJobSection6Component } from './apply-job-section6/apply-job-section6.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';

const appRoutes: Routes = [

  { path: 'applyjobsection1', component: ApplyJobSection1Component },
  { path: 'applyjobsection2', component: ApplyJobSection2Component },
  { path: 'applyjobsection3', component: ApplyJobSection3Component },
  { path: 'applyjobsection4', component: ApplyJobSection4Component },
  { path: 'applyjobsection5', component: ApplyJobSection5Component },
  { path: 'applyjobsection6', component: ApplyJobSection6Component },
  { path: '**', component: ApplyJobSection1Component }
];

@NgModule({
  declarations: [
    AppComponent,

    OffCanvasMenuComponent,
    ControlMessagesComponent,
    ApplyJobSection1Component,
    ApplyJobSection2Component,
    ApplyJobSection3Component,
    ApplyJobSection4Component,
    ApplyJobSection5Component,
    ApplyJobSection6Component,
    NavigationBarComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    BrowserAnimationsModule,
    MdButtonModule,
    MdMenuModule,
    MdCardModule,
    MdToolbarModule,
    MdIconModule,
    MdInputModule,
    MdCheckboxModule,
    MdRadioModule,
    MdProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    MdTabsModule,
    MdDatepickerModule,
    MdSelectModule,
    MdExpansionModule,
    MdNativeDateModule,
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(appRoutes),
  ],
  providers: [JobService, Educational, Experience],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts